app.addFeature(
	"sessionReminder",
	function(){

		var self = this,
			timer,
			interval,
			sessionStart = new Date().getTime(),
			sessionWarningThreshold = 60 * 5 * 1000,
			sessionWarningIssued = false,
			lastSessionActivity = new Date().getTime(),
			defaultSessionTimeout = 24 * 60 * 60 * 1000;

		/*
			Name: sessionCheck
			Use: PRIVATE.sessionCheck()
			Args: none
			Description: Performs the session check
		*/
		function sessionCheck(){
			var def = app.deferred();

			def.step(
				function(){
					const jurisdiction = app.jurisdiction.get();
					const sessionTimeoutOverride = jurisdiction?.displaySettings?.sessionTimeoutOverride ?? false;
					
					if (sessionTimeoutOverride) {
						defaultSessionTimeout = sessionTimeoutOverride;
					} else if (app.dataStore.get('session.timeout')){
						defaultSessionTimeout = app.dataStore.get('session.timeout');
					} else if (document.location.href.indexOf('/virginia') !== -1){
						defaultSessionTimeout = 30 * 60 * 1000;
					}

					if((lastSessionActivity + defaultSessionTimeout) <= (new Date().getTime() + sessionWarningThreshold) && !sessionWarningIssued){
						sessionWarningIssued = true;
						if (!sessionTimeoutOverride) {
							if(confirm('Your session is about to expire. Would you like to extend it?')){
								sessionWarningIssued = false;
								lastSessionActivity = new Date().getTime();
							}
						}
					}

					if(lastSessionActivity + defaultSessionTimeout < new Date().getTime()){
						try {
							document.location.href = '#!logout';
						}
						catch(e){}
					}
					else {
						def.next();
					}
				}
			);

			/*
				Step: Parse the results and handle appropriately
			*/
			def.step(
				function(res){
					sessionCheck.After(interval);
				}
			);


			return def.begin();
		}

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes the keep-alive interval
		*/
		self.init = function(){
			/*
				NOTE:
					Only run on the dashboard/after authentication
			*/
			if(!app.dataStore.get('session.token')){
				return this;
			}

			interval = app.static.min * 5;
			sessionCheck.After(3000);
			$(document).ready(
				function () {
				    //Zero the idle timer on mouse movement.
				    $(this).on(
				        'mousemove',
				        function(){
						 		lastSessionActivity = new Date().getTime();
				        }
				    );
				    $(this).on(
				        'keypress',
				        function(){
						 		lastSessionActivity = new Date().getTime();
				        }
				    );
				    $(this).on(
				        'click',
				        function(){
						 		lastSessionActivity = new Date().getTime();
				        }
				    );
				}
			);
		};

		return this;
	}
);
